import { Box, FlexProps } from "@chakra-ui/react";
import { listParams } from "~/api/listParams";
import { useRegions } from "~/api/resources/Regions";
import { useRef } from "react";
import { MapSVG } from "./MapSVG";

type MapGroupProps = {
  showPopup?: boolean;
};

type CommunitiesMapProps = MapGroupProps &
  FlexProps & {
    text?: string;
    onClose?: () => void;
  };

export const CommunitiesMap = ({
  showPopup,
  ...props
}: CommunitiesMapProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const { records: regions } = useRegions(listParams);

  return (
    <Box position={"relative"} ref={ref} h="100%" display="flex" {...props}>
      <MapSVG showPopup={showPopup} regions={regions} />
    </Box>
  );
};
